import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../store/store";
import { fetchBlogsAsync } from "../../../../apis/blogs/blogs";
import HomeLayout from "../../commonComponents/HomeLayout";
import LatestBlog from "./LatestBlog";
import BlogCard from "./BlogCard";

const Blogs = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { blogs, loading, error } = useSelector(
    (state: RootState) => state.blogs
  );

  useEffect(() => {
    if (blogs.length === 0) {
      dispatch(fetchBlogsAsync());
    }
  }, [blogs.length, dispatch]);

  return (
    <HomeLayout showMarquee={false}>
      <div className="flex flex-col gap-4 w-full px-5 pb-16">
        <div className="flex items-center gap-12 pt-6 flex-col w-full justify-center">
          <div className="flex flex-col gap-1 items-center max-w-[900px] justify-center">
            <h2 className="text-[40px] md:text-[56px] text-center font-bold  font-poppins">
              Trending Property Insights & Updates
            </h2>
            <span className="text-[20px] md:text-[24px] leading-[34px] text-center font-medium font-poppins">
              From housing trends to expert investment insights, we deliver the
              knowledge you need to decide with confidence.
            </span>
          </div>

          {loading && (
            <div className="w-full h-[60vh] flex items-center justify-center">
              <div className="payment-loader" />
            </div>
          )}

          {!loading && error && (
            <div className="w-full items-center justify-center h-[60vh] flex">
              <p className="text-red-500 text-lg text-center">
                Failed to load. Please try again later.
                <br />
                <span className="text-sm text-gray-500">Error: {error}</span>
              </p>
            </div>
          )}
          {!loading && !error && (
            <div className="w-full flex flex-col max-w-[1156px] gap-20 items-center">
              {blogs && blogs.length > 0 && <LatestBlog blog={blogs[0]} />}
              {blogs && blogs.length > 1 && (
                <div className="flex flex-col gap-10 items-center justify-center">
                  <h4 className="text-[38px] md:text-[44px] font-bold font-poppins">
                    Other trending insights
                  </h4>
                  <div className="grid md:grid-cols-2 grid-cols-1 lg:grid-cols-3 gap-10">
                    {blogs &&
                      blogs
                        .slice(1)
                        .map((blog, i) => <BlogCard blog={blog} key={i} />)}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </HomeLayout>
  );
};

export default Blogs;
